import axios from "axios";

const api = axios.create({
  baseURL: "https://expense-tracking-api-949992912684.us-central1.run.app/api",
  //baseURL: "http://localhost:8080/api",
});

const getLocalAccount = () => {
  const accountData = localStorage.getItem('localAccount');
  if (accountData) {
    return JSON.parse(accountData);
  } else {
    throw new Error('No local account data available');
  }
};

const getLocalExpenses = (month, year) => {
  const expenses = JSON.parse(localStorage.getItem('expenses')) || [];
  const filteredExpenses = expenses.filter((expense) => {
    const expenseDate = new Date(expense.date);
    return (
      expenseDate.getMonth() + 1 === month && // getMonth() returns 0-11, so add 1
      expenseDate.getFullYear() === year
    );
  });
  return {"data":{"expenses":filteredExpenses}};
};

const postLocalExpense = ({ account, category, amount, description, date }) => {
  const newExpense = {
    _id: new Date().getTime().toString(),
    account,
    category,
    amount: parseFloat(amount), 
    description,
    date,
  };
  const expenses = JSON.parse(localStorage.getItem('expenses')) || [];
  expenses.push(newExpense);
  localStorage.setItem('expenses', JSON.stringify(expenses));
  return {"data":newExpense};
};

const updateLocalExpense = (updatedExpense) => {
  updatedExpense.amount = parseFloat(updatedExpense.amount);
  const expenses = JSON.parse(localStorage.getItem('expenses')) || [];
  const updatedExpenses = expenses.map((expense) =>
    expense._id === updatedExpense._id ? { ...expense, ...updatedExpense } : expense
  );
  localStorage.setItem('expenses', JSON.stringify(updatedExpenses));
  return { message: 'Expense updated successfully', updatedExpense };
};

const deleteLocalExpense = (id) => {
  const expenses = JSON.parse(localStorage.getItem('expenses')) || [];
  const updatedExpenses = expenses.filter((expense) => expense._id !== id);
  localStorage.setItem('expenses', JSON.stringify(updatedExpenses));
  return { message: 'Expense deleted successfully', id };
};

const upsertLocalAccount = ({ account, budget, categories }) => {
  const newAccount = {
    account,
    budget,
    categories,
  };
  localStorage.setItem('localAccount', JSON.stringify(newAccount));
  return { message: 'Account upserted successfully', newAccount };
};

export const getAccount = async (account) => {
  if (account === "0") {
    const acct = getLocalAccount();
    return acct;
  } else {
    try {
      const response = await api.get("/account", { params: { account } });
      return response.data;
    } catch (error) {
      console.error("Error fetching account data:", error);
      throw error;
    }
  }
};

export const getExpenses = async (account, month, year) => {
  if (account === "0") {
    const expenses = getLocalExpenses(month, year);
    return expenses;
  } else {
    try {
      return await api.get("/expenses", {
        params: { account, month, year },
      });
    } catch (error) {
      console.error("Error fetching expense data:", error);
      throw error;
    }
  }
};

export const postExpense = async ({
  account,
  category,
  amount,
  description,
  date: currentTimestamp,
}) => {
  if (account === "0") {
    const newExpense = postLocalExpense({
      account,
      category,
      amount,
      description,
      date: currentTimestamp,
    });
    return newExpense;
  } else {
    try {
      return await api.post("/expenses/create", {
        account,
        category,
        amount,
        description,
        date: currentTimestamp,
      });
    } catch (error) {
      console.error("Error fetching expense data:", error);
      throw error;
    }
  }
};

export const updateExpense = async (expense) => {
  if (expense.account === "0") {
    return updateLocalExpense(expense);
  } else {
    try {
      return await api.post("/expenses/update", {
        ...expense,
      });
    } catch (error) {
      console.error("Error updating expense:", error);
      throw error;
    }
  }
};

export const deleteExpense = async (id, account) => {
  if (account === "0") {
    return deleteLocalExpense(id);
  } else {
    try {
      return await api.post("/expenses/delete", {
        id,
      });
    } catch (error) {
      console.error("Error deleting expense:", error);
      throw error;
    }
  }
};

export const upsertAccount = async ({ account, budget, categories }) => {
  if (account === "0") {
    return upsertLocalAccount({ account, budget, categories });
  } else {
    try {
      return await api.post("/account", {
        account,
        budget,
        categories,
      });
    } catch (error) {
      console.error("Error upserting account data:", error);
      throw error;
    }
  }
};
